interface Props {
  title: string
}
export default function MobileMenuItem({title}: Props) {
  return (
    <div className="w-[100%] flex flex-row justify-between align-middle items-center mt-5 p-2 px-4 rounded-lg">
      <div className="flex flex-row align-middle items-center">
        <h1 className="text-lg font-semibold text-center text-primary">
          {title}
        </h1>
      </div>
      <div>
        <svg
          width="10"
          height="15"
          viewBox="0 0 10 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 1.5L2 7.5L8 13.5"
            stroke="#00214D"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}
